// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getErrorSelector } from '@tcp/core/src/utils/utils.extension';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../../utils/labels/labelUtilty';
import labelsObj, { ACCOUNT_PAYMENTGC } from '../../Payment.labels';

export const getAddGiftCardResponse = (state) => {
  return state.AddGiftCardReducer?.get('showUpdatedNotification');
};

export const getshowNotification = (state) => {
  return state.AddGiftCardReducer?.get('showNotification');
};

export const getAddGiftCardError = (state) => {
  return state.AddGiftCardReducer?.get('error');
};

export const getOnAddGiftCardPageState = (state) => {
  return state.AddGiftCardReducer?.get('onAddGiftCardPage');
};

export const getAddGiftCardErrorMessage = createSelector(getAddGiftCardError, (state) => {
  const labels = getLabelFromCopyOrFromTranslation(ACCOUNT_PAYMENTGC, labelsObj);
  labels.lbl_paymentGC_error__ERR_INVALID_PIN_CARD = getDynamicLabelValues(
    'dynamic.account_d.lbl_paymentGC_error__ERR_INVALID_PIN_CARD'
  );
  return getErrorSelector(state, labels, 'lbl_paymentGC_error');
});
